import React from 'react';

const BatterSilhouette: React.FC = () => (
    <g stroke="none" fill="none" fillRule="evenodd">
        <g transform="translate(2, 1)">
            <polygon
                fill="#DCDDDF"
                points="65.9974171 0.000190243902 48.2371976 5.34984878 38.1276366 9.03677561 17.0533683 16.2964829 16.852661 18.1114098 18.0759293 18.6964098 39.6248561 12.7037268 49.0485878 10.359922 56.918978 8.03514146 67.6810756 4.65070244 68.0739293 3.36750732 67.1607585 0.570921951"
            />
            <polygon
                fill="#DCDDDF"
                points="0.0890341463 21.2964732 -0.000380487805 21.8776683 0.0890341463 22.704278 0.760595122 24.5810341 1.96674146 25.6321317 2.50322927 25.520839 2.63735122 25.1850585 1.22954634 21.2964732 0.670229268 20.983522"
            />
            <polygon
                fillOpacity="0.44"
                fill="#A5A6A7"
                points="17.9917463 22.3020073 23.2215512 25.1185683 25.5016244 26.1240073 28.0489902 26.9953244 21.6796244 32.024422 20.070161 30.1248366 14.9297707 26.3247146"
            />
            <polygon
                fill="#E4E6EA"
                points="17.9917463 22.3020073 23.2215512 25.1185683 25.5016244 26.1240073 28.0489902 26.9953244 21.6796244 32.024422 20.070161 30.1248366 14.9297707 26.3247146"
            />
            <polygon
                fill="#E4E6EA"
                points="30.8878098 134.275763 29.1889317 135.080495 25.8368341 136.555837 21.6800049 137.98552 19.7575902 138.96908 18.9081512 140.936202 19.4893463 142.098593 23.7802976 143.394154 29.367761 143.394154 32.9443463 142.992739 35.9834927 142.858617 37.8164927 143.394154 43.0462976 143.082154 42.7999317 138.834959 39.872078 137.493739"
            />
            <polygon
                fill="#E4E6EA"
                points="35.1342439 147.909022 31.6023659 149.831437 28.2949756 150.725583 26.5513902 152.065851 26.3288049 153.09412 26.3288049 154.43629 30.6644634 155.776559 39.1122439 156.000095 40.6322927 155.642437 43.8959268 154.703583 48.6786585 154.837705 54.6675366 154.033924 55.6958049 152.512924 55.293439 150.367924 39.4261463 144.95929"
            />
            <polygon
                fill="#DCDDDF"
                points="30.5301512 71.7850171 31.3348829 74.1640171 29.4571756 78.9914561 27.0439317 83.0493585 23.4901756 91.9347 20.2712488 99.3513585 19.1982732 101.870188 19.1982732 104.318627 20.0705415 107.676432 22.8119561 111.454676 25.2670537 115.793188 31.8038341 129.505968 32.4078585 130.415334 32.8768098 131.464529 32.2737366 132.584115 31.066639 132.584115 30.4635659 133.563871 31.4242976 135.313163 33.2125902 136.432749 39.9691024 139.506139 40.3866878 124.32848 32.2737366 98.651261 34.0163707 79.6211634 31.4690049 72.6943829"
            />
            <polygon
                fill="#E4E6EA"
                points="30.5301512 71.7850171 31.3348829 74.1640171 29.4571756 78.9914561 27.0439317 83.0493585 23.4901756 91.9347 20.2712488 99.3513585 19.1982732 101.870188 19.1982732 104.318627 20.0705415 107.676432 22.8119561 111.454676 25.2670537 115.793188 31.8038341 129.505968 32.4078585 130.415334 32.8768098 131.464529 32.2737366 132.584115 31.066639 132.584115 30.4635659 133.563871 31.4242976 135.313163 33.2125902 136.432749 39.9691024 139.506139 40.3866878 124.32848 32.2737366 98.651261 34.0163707 79.6211634 31.4690049 72.6943829"
            />
            <polygon
                fill="#DCDDDF"
                points="25.5014341 24.3135512 27.1108976 25.855478 27.2450195 26.9959902 32.2731659 24.3135512 36.8009707 23.1816 33.4802634 19.888478 33.8160439 14.6586732 25.5014341 14.1221854"
            />
            <polygon
                fill="#DCDDDF"
                points="19.2657146 12.3786 19.6005439 15.6641122 21.0093 18.8155024 22.2163976 20.5590878 22.811861 22.2351366 25.5009585 24.3135512 28.5182268 23.978722 32.4077634 19.1503317 32.7425927 16.2006 32.0320317 10.0366976 23.5566659 10.9032585"
            />
            <polygon
                fill="#EDEEF0"
                points="1.22926098 21.2962829 1.60879756 20.2908439 2.15479756 20.0625512 3.03943171 18.8820878 4.24652927 18.8820878 5.11784634 17.9441854 6.3249439 17.9441854 7.12967561 17.5418195 8.00099268 17.8766488 9.54387073 20.5590878 10.4817732 20.5590878 11.4206268 22.301722 11.4206268 24.3135512 10.1469439 26.3253805 9.94623659 29.2751122 11.4206268 32.9629902 14.0355293 36.1143805 13.6331634 39.8022585 19.7352366 45.9709171 14.9077976 47.0438927 11.2865049 48.7865268 5.38609024 47.8476732 4.44723659 43.8249659 4.58135854 37.6563073 4.11240732 27.9338927 2.63706585 25.1848683"
            />
            <polygon
                fill="#EDEEF0"
                points="8.73885366 17.541439 8.00165854 17.8762683 9.54358537 20.5587073 11.4212927 24.3131707 13.2086341 25.341439 13.8345366 26.325 14.9293902 26.325 16.0470732 26.1014634 18.1930244 24.5367073 18.7941951 22.7341463 18.2149024 21.9332195 18.5278537 20.5587073 18.4365366 19.1509024 17.3882927 17.831561 16.9193415 15.3289024 15.309878 14.5907561 14.3491463 14.724878 13.6338293 13.9876829 12.5827317 14.1218049 12.2031951 14.724878 11.2196341 14.6801707 10.3701951 15.3507805 10.2360732 15.8206829 9.47604878 15.842561 8.87297561 16.7367073"
            />
            <polygon
                fill="#DCDDDF"
                points="35.5589634 21.2962829 34.9558902 22.5033805 31.6028415 23.5088195 27.2443537 26.9959902 25.8365488 27.9338927 22.812622 44.4813073 25.0318171 56.9670146 25.0318171 58.7771854 26.8419878 64.3427707 27.5801341 65.817161 26.9095244 68.7003073 28.4514512 69.7066976 35.5589634 66.2870634 36.9667683 64.811722 47.2932073 61.7944537 49.103378 61.7278683 50.3095244 59.6485024 50.3095244 57.5035024 48.2986463 55.1568439 48.6334756 53.9497463 47.9628659 52.7426488 48.1645244 46.9097707 47.694622 45.5010146 47.9628659 39.6681366 47.4939146 33.6336 47.5605 30.6829171 45.2138415 26.123722 41.8617439 22.8382098 37.7049146 21.2962829"
            />
            <polygon
                fill="#DCDDDF"
                points="25.8366439 27.934178 20.3861561 31.712422 19.5909366 32.531422 18.2915707 33.1639829 16.7382293 34.5090073 14.0358146 36.1146659 13.6334488 39.8015927 19.735522 45.9702512 28.1833024 41.8809585 30.3292537 41.9475439 31.4022293 42.7522756 33.0307171 41.0733732 34.2853756 39.8015927 32.4742537 36.5170317 27.3861805 31.5231293"
            />
            <g transform="translate(13.317073, 12.365854)">
                <polygon
                    fillOpacity="0.24"
                    fill="#EDEEF0"
                    points="12.184361 35.6833829 19.0902146 45.9422854 27.5712878 48.5571878 17.8346049 41.1814317"
                />
                <polygon
                    fillOpacity="0.24"
                    fill="#EDEEF0"
                    points="21.6384366 40.3768902 25.7952659 44.4671341 29.8855098 47.2827439 24.8564122 45.2043293"
                />
                <polygon
                    fillOpacity="0.24"
                    fill="#EDEEF0"
                    points="22.5771 51.5742659 17.8343195 49.3617293 11.1111 38.3656317 13.793539 50.266339 15.5371244 54.3232902 15.1347585 55.5303878 18.0511976 54.8264854"
                />
                <polygon
                    fillOpacity="0.24"
                    fill="#EDEEF0"
                    points="25.7619732 41.2485878 27.5711927 43.8301976 30.8243634 45.673661 28.7459488 43.1928805"
                />
                <polygon
                    fillOpacity="0.24"
                    fill="#EDEEF0"
                    points="30.8242683 27.0339439 28.7458537 23.4801878 23.4846585 25.2570659 28.2930732 25.2570659"
                />
                <polygon
                    fill="#E0E1E3"
                    points="2.73028537 26.1622463 6.68640732 25.2566854 9.23377317 24.5870268 5.98250488 26.1622463"
                />
                <polygon
                    fill="#E0E1E3"
                    points="13.1900854 27.0339439 9.49554878 29.3806024 7.49037805 31.8613829 11.7147439 30.0512122"
                />
                <polygon
                    fill="#D0D0D9"
                    points="10.8098488 0.213929268 11.144678 0.817002439 10.9772634 3.86851463 11.9998244 4.22522195 10.4074829 4.06922195"
                />
                <polygon
                    fill="#D0D0D9"
                    points="14.9333854 6.08076585 12.184361 6.08076585 10.1725317 6.78466829 10.4074829 6.43271707 11.9998244 5.74593659"
                />
                <polygon
                    fill="#EDEEF0"
                    points="15.6933146 79.4448073 13.7937293 80.2048317 10.7317537 84.4510756 15.6933146 80.6966122"
                />
                <polygon fill="#EDEEF0" points="15.4250707 83.0655293 10.1058512 87.0102366 15.6933146 84.2279195" />
                <path
                    d="M14.9780927,91.6479073 C14.8439707,91.6926146 12.5191902,92.1396878 12.5191902,92.1396878 L11.2683366,92.5420537 L15.2016293,92.5420537 L14.9780927,91.6479073 Z"
                    fill="#EDEEF0"
                />
                <polygon
                    fill="#EDEEF0"
                    points="15.0675073 93.8508366 11.2683366 93.8508366 13.2345073 94.6879098 15.2016293 95.0902756"
                />
                <polygon
                    fill="#EDEEF0"
                    points="14.575822 96.7437805 12.6981146 96.7437805 11.2684317 95.8049268 12.9216512 97.3696829 14.575822 97.9061707"
                />
                <polygon fill="#EDEEF0" points="15.2016293 85.7922 13.2345073 87.8487366 15.2016293 86.5075171" />
                <polygon fill="#EDEEF0" points="20.3365024 119.361973 23.9178439 120.837315 24.5884537 121.57451" />
                <polygon
                    fill="#DCDDDF"
                    points="0.942278049 3.40993171 2.28349756 3.81229756 2.73057073 4.61702927 3.22235122 6.26549268 2.08183902 5.91354146 2.08183902 5.01939512"
                />
            </g>
            <polygon
                fill="#EDEEF0"
                points="49.1030927 61.7274878 51.1815073 64.0741463 51.1815073 64.8113415 52.6568488 66.2200976 54.4670195 69.7063171 55.3383366 74.0648049 54.936922 78.2216341 53.7298244 81.7088049 49.7737024 86.6028293 46.7564341 90.1565854 45.0128488 93.2413902 43.8732878 97.2640976 42.9344341 104.237488 41.7948732 111.345 45.2145073 117.043756 47.3595073 121.737073 48.5666049 127.570902 51.6514098 137.159195 55.3383366 144.668122 56.0089463 150.367829 50.3101902 150.367829 43.1360927 148.021171 38.6434829 145.003902 41.1242634 142.925488 42.331361 140.511293 40.1188244 138.701122 37.235678 130.319927 35.3579707 125.693195 30.5971171 117.98261 27.8480927 113.423415 27.1108976 109.936244 27.7139707 106.85239 28.7194098 90.8271951 31.736678 77.1486585 31.4018488 74.0648049 31.4684341 72.657 30.5305317 71.7847317 29.7258 69.7063171 29.6848976 69.0899268 35.558678 66.2866829 36.9674341 64.8113415 47.292922 61.7940732"
            />
            <polygon
                fill="#003451"
                points="48.6336659 62.6326683 50.3097146 65.0126195 43.4371537 67.1918634 42.0626415 64.7110829"
            />
            <polygon
                fill="#003451"
                points="35.4248415 67.1920537 36.5615488 69.7061268 33.4130122 71.3155902 32.2734512 68.9689317"
            />
            <polygon
                fill="#003451"
                points="31.033061 69.7064122 32.2734512 71.9189488 31.6532561 72.2204854 30.4632805 70.1753634"
            />
            <g transform="translate(24.731707, 15.219512)">
                <path
                    d="M5.39617317,95.052322 C5.39617317,95.052322 7.3328561,96.6541756 10.4918561,95.5212732 C14.0456122,94.2475902 17.8000756,86.0680537 17.8000756,86.0680537 C17.8000756,86.0680537 13.6641732,91.1171268 12.1679049,92.5715415 C9.68522195,94.9857366 5.39617317,95.052322 5.39617317,95.052322"
                    fill="#E4E6EA"
                />
                <polygon fill="#E4E6EA" points="22.6280854 72.9035561 11.5986951 82.1303854 9.68579268 85.3968732" />
                <polygon
                    fill="#E4E6EA"
                    points="18.8061805 78.6249512 13.8446195 85.3966829 11.597839 89.6885854 14.6493512 85.3966829"
                />
                <path
                    d="M22.0246317,57.9735951 C22.0246317,57.9735951 19.0073634,55.7439366 15.8559732,55.7439366 C12.7045829,55.7439366 9.28494878,58.375961 9.28494878,58.375961 C9.28494878,58.375961 12.8406073,57.5046439 15.6552659,57.5046439 C18.4689732,57.5046439 22.0246317,57.9735951 22.0246317,57.9735951"
                    fill="#DDE0E5"
                />
                <polygon fill="#E4E6EA" points="13.9114902 112.954654 26.5836366 129.739873 24.9075878 128.912312" />
                <polygon fill="#E4E6EA" points="22.0915976 128.175022 14.783378 118.720851 16.156939 121.805656" />
                <polygon fill="#E4E6EA" points="11.5983146 104.774546 6.24580244 101.020083 7.54136341 102.56201" />
                <polygon
                    fill="#E4E6EA"
                    points="6.60308049 97.3320146 10.2909585 97.3320146 12.2352512 96.5272829 8.34666585 98.4715756"
                />
                <polygon fill="#DDE0E5" points="21.0858732 61.1695976 12.6371415 62.1978659 8.12265366 64.0755732" />
                <polygon
                    fill="#DDE0E5"
                    points="22.2480732 63.0470195 14.9617317 65.4165073 9.28485366 68.1427024 18.806561 65.237678"
                />
                <polygon
                    fill="#DDE0E5"
                    points="22.6280854 65.2372976 14.6045488 68.7235171 7.67586585 72.7471756 15.2019146 69.4388341"
                />
                <polygon
                    fill="#E4E6EA"
                    points="19.4096341 73.2386707 12.8167317 76.099939 10.2237073 78.0661098 8.74836585 80.7485488"
                />
                <path
                    d="M10.2238024,101.019798 C10.9391195,101.220505 12.9956561,101.514432 12.9956561,101.514432 L17.3313146,101.514432 L12.2356317,102.977407 L10.2238024,101.019798 Z"
                    fill="#E4E6EA"
                />
                <polygon
                    fill="#D0D0D9"
                    points="7.67586585 3.93110488 3.78728049 8.7585439 0.770012195 9.09432439 1.82015854 9.40727561 4.39035366 9.09432439 8.21235366 4.62359268 8.46347561 0.980421951 7.95552439 0.498153659"
                />
            </g>
            <polygon
                fill="#003451"
                points="17.0530829 13.4513854 19.735522 12.2176537 23.5565707 10.9030683 26.9781073 10.5530195 32.0909122 10.5482634 32.0385951 13.3505561 32.6873268 15.7181415 33.6547171 17.1754098 35.223278 17.1754098 35.9614244 15.2615561 35.9614244 11.4395561 34.6867902 9.69692195 33.9495951 6.20975122 32.8433268 4.26165366 31.1511073 2.79011707 27.7809366 1.51643415 23.9589366 1.51643415 20.8075463 2.72353171 18.6625463 4.66782439 17.5895707 7.14860488 17.8578146 11.573678 16.8523756 12.9148976"
            />
            <polygon
                fillOpacity="0.24"
                fill="#4C4C4C"
                points="33.7820854 9.83066341 32.0908171 10.5478829 26.9789634 10.5535902 23.5564756 10.903639 19.7354268 12.2172732 17.0529878 13.4510049 16.8522805 12.9145171 17.8577195 11.5742488 20.0702561 9.76407805 23.5231829 8.52273659 27.6467195 8.18790732 31.670378 8.69110244 33.3131341 8.95934634"
            />
        </g>
    </g>
);

export default BatterSilhouette;
